export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';

export interface AppGlobalsState {
  isLoading?: boolean;
  message?: string;
  hasError?: boolean;
  errorMessage?: string;
}

export interface SetLoadingActionType extends AppGlobalsState {
  type: typeof SET_LOADING;
  isLoading: boolean;
  message?: string;
}

export interface SetErrorActionType extends AppGlobalsState {
  type: typeof SET_ERROR;
  hasError: boolean;
  errorMessage?: string;
}

export type AppGlobalsActionTypes = SetErrorActionType | SetLoadingActionType;
